import C from './component';
import './style.css';

export default C;

export { eatToast, updateToast, raiseToast, isToastActive, TOAST_POSITION } from './component';
